/**
 * Normalise une chaîne pour comparaison locale : minuscules, sans diacritiques.
 */
export function u2000NormalizeForMatch(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLocaleLowerCase();
}

/**
 * Correspondance contains insensible à la casse et aux accents.
 * needle vide → true (aucun filtre actif).
 */
export function u2000MatchContainsAccentInsensitive(haystack: string, needle: string): boolean {
  if (!needle.trim()) {
    return true;
  }
  return u2000NormalizeForMatch(haystack).includes(u2000NormalizeForMatch(needle));
}

export type U2000LabelHighlightSegment = {
  text: string;
  highlighted: boolean;
};

/**
 * Découpe un libellé pour surligner la première occurrence du buffer typeahead
 * (même règles que le filtre : contains, casse et accents ignorés).
 */
export function u2000SplitLabelForTypeaheadHighlight(label: string, query: string): U2000LabelHighlightSegment[] {
  const trimmedQuery = query.trim();
  if (!trimmedQuery) {
    return [{ text: label, highlighted: false }];
  }

  const normLabel = u2000NormalizeForMatch(label);
  const normQuery = u2000NormalizeForMatch(trimmedQuery);
  const matchStart = normLabel.indexOf(normQuery);
  if (matchStart === -1) {
    return [{ text: label, highlighted: false }];
  }

  const matchEndNorm = matchStart + normQuery.length;
  const segments: U2000LabelHighlightSegment[] = [];
  let normPos = 0;
  let buffer = '';
  let bufferHighlighted = false;

  for (const char of label) {
    const charNorm = u2000NormalizeForMatch(char);
    const charNormStart = normPos;
    const charNormEnd = normPos + charNorm.length;
    normPos = charNormEnd;

    const inMatch = charNormEnd > matchStart && charNormStart < matchEndNorm;
    if (buffer && inMatch !== bufferHighlighted) {
      segments.push({ text: buffer, highlighted: bufferHighlighted });
      buffer = '';
    }
    if (!buffer) {
      bufferHighlighted = inMatch;
    }
    buffer += char;
  }

  if (buffer) {
    segments.push({ text: buffer, highlighted: bufferHighlighted });
  }

  return segments.length > 0 ? segments : [{ text: label, highlighted: false }];
}
